import { FETCH_STEEL_SMELTER_DATA_FREE } from '../../actions';

export default (state = {}, action) => {
	switch (action.type) {
		case FETCH_STEEL_SMELTER_DATA_FREE:
			return action.payload;
		default:
			return state;
	}
};
